import capitalizeFirstLetter from '../../utils/utils';
import { Button, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';

const ConfirmationDialog = ({ itemsToDelete, openConfirm, handleCloseConfirm, handleDelete }) => {
  const isMultiple = itemsToDelete.length > 1;

  return (
    <Dialog maxWidth="sm" fullWidth open={openConfirm} onClose={handleCloseConfirm}>
      <DialogTitle>
        {isMultiple
          ? `Está a punto de eliminar ${itemsToDelete.length} entradas de la base de datos, ¿está seguro?`
          : `Está a punto de eliminar una entrada de la base de datos, ¿está seguro?`}
      </DialogTitle>
      <DialogActions>
        <Button onClick={handleCloseConfirm} color="primary">
          Cancelar
        </Button>
        <Button onClick={handleDelete} color="secondary">
          Eliminar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;